import { Store, createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
// `react-router-redux` is deprecated, so we use `connected-react-router`.
// This provides a Redux middleware which connects to our `react-router` instance.
// We'll be using Redux Devtools. We can use the `composeWithDevTools()`
// directive so we can pass our middleware along with it
import { composeWithDevTools } from 'redux-devtools-extension'
// If you use react-router, don't forget to pass in your history type.

// Import the state interface and our combined reducers/sagas.
import {IApplicationState, rootReducer, rootSaga} from './store'

export default function configureStore(
    initialState: IApplicationState
): Store<any /* IApplicationState */> {
    // create the composing function for middlewares
    const composeEnhancers = composeWithDevTools({});
    // create the redux-saga middleware
    const sagaMiddleware = createSagaMiddleware();
    const appliedMiddleware = applyMiddleware(sagaMiddleware);
    const prod = (process.env.NODE_ENV !== 'production');
    // create our store with the combined reducers/sagas, and the initial Redux state that
    // passes from entry point.

    const store = createStore(
        rootReducer,
        initialState,
        prod ? appliedMiddleware : composeEnhancers(appliedMiddleware)
    );

    // Don't forget to run the root saga, and return the store object.
    sagaMiddleware.run(rootSaga);
    //
    // if (module.hot) {
    //     // Enable Webpack hot module replacement for reducers
    //     module.hot.accept('../reducers', () => {
    //         const nextRootReducer = require('../reducers/index');
    //         store.replaceReducer(nextRootReducer);
    //     });
    // }

    return store;
}